import { configEnableTrue } from "../../common/components/PivotTable/commonPropertyConfig";
import { NbiDimensions } from "../../common/generic/generic-nbi-dimensions";
import { AgFormat } from "../../common/utils/agGridFormat";
import { Functions } from "../../common/utils/clientlistHelper";
import { widgetNames } from "./helper";
const attrs = new NbiDimensions();

// tslint:disable-next-line:no-big-function
export function getAllHeaders(
  widgetName: string
): {
  attributeHeaders: any[];
  kpiHeaders: any[];
} {
  return {
    attributeHeaders:
      widgetName === widgetNames.CLIENTGROUP ? groupAttributes : attributes,
    kpiHeaders: kpis,
  };
}
const defaultNumberCellStyle = {
  "padding-right": "40px",
  "text-align": "right",
};
const defaultSmallNumberCellStyle = {
  "padding-right": "20px",
  "text-align": "right",
};
const defaultPercentCellClass = "text-right percent";

const attributes = [
  {
    cellRenderer: Functions.hlinkFunction,
    ...configEnableTrue,
    field: "clientgen_id",
    headerName: "Portfolio Client Id",
  },
  {
    cellRenderer: Functions.hlinkFunction,
    ...configEnableTrue,
    field: "clientgen_name",
    headerName: "Portfolio Client Name",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_CORIGRPSEGMENT,
    headerName: "GLBA client segment",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_CORI_CTRY_AXIS,
    headerName: "GLBA client steering country",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_CORIGRPCOMID,
    headerName: "GLBA client group ID",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_CORIGRPNAME,
    headerName: "GLBA client group name",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_GEN_COM_CTRY_LABEL,
    headerName: "Portfolio Client Country",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_GEN_REG_NAME,
    headerName: "Portfolio Client Region",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_GEN_SUB_REG_NAME,
    headerName: "Portfolio Client Sub Region",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_GEN_FUP_CLASS_LABEL,
    headerName: "Portfolio PCRU",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_GEN_SEGMENT,
    headerName: "Portfolio Client Segment",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_COUNTRY,
    headerName: "Commercial country of LE",
  },
  {
    cellRenderer: Functions.hlinkFunctionForLE,
    ...configEnableTrue,
    field: attrs.CLIENT_LEID,
    headerName: "Client Legal Entity Id",
  },
  {
    cellRenderer: Functions.hlinkFunctionForLE,
    ...configEnableTrue,
    field: attrs.CLIENT_LENAME,
    headerName: "Client Legal Entity",
  },
  {
    cellRenderer: Functions.hlinkFunctionForSubGroup,
    ...configEnableTrue,
    field: attrs.SUB_GRP_ID,
    headerName: "Client Sub Group Id",
  },
  {
    cellRenderer: Functions.hlinkFunctionForSubGroup,
    ...configEnableTrue,
    field: attrs.SUB_GRP_FULL_NAME,
    headerName: "Client Sub Group",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_GEN_CTRY_AXIS_LABEL,
    headerName: "Portfolio Client Steering Country",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_GEN_TYPL1,
    headerName: "Typology Level 1",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_GEN_TYPL2,
    headerName: "Typology Level 2",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_GEN_TYPL3,
    headerName: "Typology Level 3",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "fpv_beresctryname",
    headerName: "Booking Country",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "fpv_beshortlabel",
    headerName: "Booking Entity",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "agency_declongname",
    headerName: "Booking Place",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "fpv_oeresctryname",
    headerName: "Originating Country",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "fpv_oeresregcode",
    headerName: "Originating Region",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "fpv_oeshortlabel",
    headerName: "Originating Entity",
  },
  {
    cellRenderer: Functions.fpvBlHlink,
    ...configEnableTrue,
    field: "fpv_bl",
    headerName: "Business Line",
  },
  {
    cellRenderer: Functions.fpvSblHlink,
    ...configEnableTrue,
    field: "fpv_sbl",
    headerName: "Sub Business Line",
  },
  {
    cellRenderer: Functions.fpvSsblHlink,
    ...configEnableTrue,
    field: "fpv_ssbl",
    headerName: "Sub Sub Business Line",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "product_l1",
    headerName: "Product Level1",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "product_l2",
    headerName: "Product Level2",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "product_l3",
    headerName: "Product Level3",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_LEADCORIBANKER,
    headerName: "GLBA client lead banker",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_GEN_LEVEL,
    headerName: "Portfolio Client Level",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.SALESBEN_SALES_LOCATION,
    headerName: "Sales Location",
  },
  {
    cellRenderer: Functions.hlinkFunctionForLERct,
    ...configEnableTrue,
    field: attrs.CLIENT_LE_RCT_CODE,
    headerName: "Client RCT for Legal Entity",
  },
  {
    cellRenderer: Functions.hlinkFunctionForGroup,
    ...configEnableTrue,
    field: attrs.CLIENT_GRPID,
    headerName: "Client Group Id",
  },
  {
    cellRenderer: Functions.hlinkFunctionForGroup,
    ...configEnableTrue,
    field: attrs.GRP_FULL_NAME,
    headerName: "Client Group Name",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "gbis_level_1_functional_label",
    headerName: "NBI breakdown level 1",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "gbis_level_6_functional_label",
    headerName: "NBI breakdown level 6",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "gbis_level_7_functional_label",
    headerName: "NBI breakdown level 7",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.PRODUCT_LABEL,
    headerName: "Product Label",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.PRODUCT_CODE,
    headerName: "Product Code",
  },
];

const groupAttributes = [
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_GRPID,
    headerName: "Client Group BDR CCIAL ID",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "client_grpname",
    headerName: "Client Group Name",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "client_grpcomcontinentname",
    headerName: "Client Group Continent Name",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "client_grpcountryaxis",
    headerName: "Client Group Country Axis",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "client_grpcomctrygrpname",
    headerName: "Client Group Country Grouping Name",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "client_grpcomctryname",
    headerName: "Client Group Country Name",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_GRP_FUP_CLASS_LABEL,
    headerName: "Client Group PCRU",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "client_grpcomregname",
    headerName: "Client Group Region Name",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "client_grpcomsubregname",
    headerName: "Client Group Sub Region Name",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "client_grpsegment",
    headerName: "Client Group Segment",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "client_grptypl1name",
    headerName: "Client Group Typology Level 1",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "client_grptypl2name",
    headerName: "Client Group Typology Level 2",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "client_grptypl3name",
    headerName: "Client Group Typology Level 3",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "client_subgrpid",
    headerName: "Client Sub Group BDR CCIAL ID",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "client_subgrpname",
    headerName: "Client Sub Group Name",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "client_leid",
    headerName: "Client LE BDR CCIAL ID",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "client_lename",
    headerName: "Client LE Name",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "client_eccomid",
    headerName: "Client EC BDR CCIAL ID",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "client_ecfullname",
    headerName: "Client EC Name",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "fpv_beresctryname",
    headerName: "Booking Entity Country",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "fpv_beresreg",
    headerName: "Booking Entity Region",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "fpv_oeresctryname",
    headerName: "Originating Entity Country",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "fpv_oeresreg",
    headerName: "Originating Entity Region",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "fpv_bl",
    headerName: "Business Line",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "fpv_sbl",
    headerName: "Sub Business Line",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "fpv_ssbl",
    headerName: "Sub Sub Business Line",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "gbis_level_1_functional_label",
    headerName: "NBI breakdown level 1",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "gbis_level_6_functional_label",
    headerName: "NBI breakdown level 6",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "gbis_level_7_functional_label",
    headerName: "NBI breakdown level 7",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "product_l1",
    headerName: "Product Level1",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "product_l2",
    headerName: "Product Level2",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: "product_l3",
    headerName: "Product Level3",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.PRODUCT_LABEL,
    headerName: "Product Label",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.PRODUCT_CODE,
    headerName: "Product Code",
  },
  {
    cellRenderer: Functions.suppressCount,
    ...configEnableTrue,
    field: attrs.CLIENT_LE_RCT_CODE,
    headerName: "Client RCT for Legal Entity",
  },
];

const kpis = [
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_ytd",
    headerName: "NBI YTD",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_h1",
    headerName: "NBI H1",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_ytd_gbis",
    headerName: "NBI YTD-GBIS",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_ytd_ib",
    headerName: "NBI YTD-IB",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_ytd_nongbis",
    headerName: "NBI YTD-Non GBIS",
    width: 160,
  },
  {
    aggFunc: "sum",
    cellClass: defaultPercentCellClass,
    cellRenderer: Functions.calculateNbiVar,
    comparator: AgFormat.AgNumberComparatorNumeric,
    enableValue: true,
    field: "nbi_ytd_var_yoy",
    headerName: "NBI YTD var YoY",
    width: 160,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_ytd_1",
    headerName: "NBI YTD-1",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_ytd_2_gbis",
    headerName: "NBI YTD-2 GBIS",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_ytd_3_gbis",
    headerName: "NBI YTD-3 GBIS",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_ytd_ib_1",
    headerName: "NBI YTD-1 IB",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_ytd_1_gbis",
    headerName: "NBI YTD-1 GBIS",
    width: 160,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_ytd_2",
    headerName: "NBI YTD Y-2",
    width: 160,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_ytd_3",
    headerName: "NBI YTD Y-3",
    width: 160,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_fy_1",
    headerName: "NBI FY-1",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_fy_1_ib",
    headerName: "NBI FY-1 - IB",
    width: 160,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_fy_2_ib",
    headerName: "NBI FY-2 - IB",
    width: 160,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultSmallNumberCellStyle,
    enableValue: true,
    field: "nbi_fy_3_ib",
    headerName: "NBI FY-3 - IB",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_fy_1_gbis",
    headerName: "NBI FY-1 - GBIS",
    width: 160,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_fy_2",
    headerName: "NBI FY Y-2",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_fy_3",
    headerName: "NBI FY Y-3",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_mtd",
    headerName: "NBI MTD",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_mtd_1",
    headerName: "NBI MTD Y-1",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellClass: defaultPercentCellClass,
    cellRenderer: Functions.calculateNbiVar,
    comparator: AgFormat.AgNumberComparatorNumeric,
    enableValue: true,
    field: "nbi_fy_var_yoy",
    headerName: "NBI FY var YoY",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_forcast_y1",
    headerName: "NBI Forecast YR1",
    width: 160,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_forcast_y1_gbis",
    headerName: "NBI Forecast YR1 - GBIS",
    width: 200,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_forcast_y1_ib",
    headerName: "NBI Forecast YR1 - IB",
    width: 200,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_forcast_y1_nongbis",
    headerName: "NBI Forecast YR1 - Non GBIS",
    width: 200,
  },
  {
    aggFunc: "sum",
    cellClass: defaultPercentCellClass,
    cellRenderer: Functions.calculateNbiVar,
    comparator: AgFormat.AgNumberComparatorNumeric,
    enableValue: true,
    field: "nbi_forcast_y1_var_yoy",
    headerName: "NBI Forecast YR1 var YoY",
    width: 200,
  },
  {
    aggFunc: "sum",
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_rwa_avg",
    headerName: "RWA AVG YTD",
    width: 160,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_rwa_gbis",
    headerName: "RWA AVG YTD - GBIS",
    width: 200,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_rwa_fy_1",
    headerName: "RWA AVG FY-1",
    width: 150,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_rwa_fy_1_gbis",
    headerName: "RWA AVG FY-1 - GBIS",
    width: 200,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_rwa_fy_2",
    headerName: "RWA AVG FY-2",
    width: 150,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_rwa_fy_3",
    headerName: "RWA AVG FY-3",
    width: 150,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_rwa_last_period",
    headerName: "RWA Last Period",
    width: 150,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_forcast_rwa_y1",
    headerName: "RWA Forecast YR1",
    width: 160,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_forcast_rwa_y1_gbis",
    headerName: "Rwa Forecast YR1 - GBIS",
    width: 200,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_forcast_rwa_y1_ib",
    headerName: "RWA Forecast YR1 - IB",
    width: 200,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_forcast_rwa_y1_nongbis",
    headerName: "Rwa Forecast YR1 - Non GBIS",
    width: 200,
  },
  {
    aggFunc: "sum",
    cellClass: defaultPercentCellClass,
    cellRenderer: Functions.calculateNbiVar,
    comparator: AgFormat.AgNumberComparatorNumeric,
    enableValue: true,
    field: "nbi_forecast_rwa_y1_vs_fy_1",
    headerName: "RWA Forecast YR1 vs FY-1",
    width: 200,
  },
  {
    aggFunc: "sum",
    cellClass: defaultPercentCellClass,
    cellRenderer: Functions.calculateNbiVar,
    comparator: AgFormat.AgNumberComparatorNumeric,
    enableValue: true,
    field: "nbi_forecast_rwa_y2_vs_fy_1",
    headerName: "RWA Forecast YR2 vs FY-1",
    width: 200,
  },
  {
    aggFunc: "sum",
    cellClass: defaultPercentCellClass,
    cellRenderer: Functions.calculateNbiVar,
    comparator: AgFormat.AgNumberComparatorNumeric,
    enableValue: true,
    field: "nbi_rwa_vs_fy_1",
    headerName: "RWA YTD vs FY-1",
    width: 160,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimalWithPercentage,
    cellStyle: defaultNumberCellStyle,
    comparator: AgFormat.AgNumberComparatorNumeric,
    enableValue: true,
    field: "nbi_rgcp",
    headerName: "RGCP AVG YTD",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimalWithPercentage,
    cellStyle: defaultNumberCellStyle,
    comparator: AgFormat.AgNumberComparatorNumeric,
    enableValue: true,
    field: "nbi_rgcp_gbis",
    headerName: "RGCP AVG YTD GBIS",
    width: 160,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimalWithPercentage,
    cellStyle: defaultNumberCellStyle,
    comparator: AgFormat.AgNumberComparatorNumeric,
    enableValue: true,
    field: "nbi_forcast_rgcp_y1",
    headerName: "RGCP Forecast YR1",
    width: 160,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimalWithPercentage,
    cellStyle: defaultNumberCellStyle,
    comparator: AgFormat.AgNumberComparatorNumeric,
    enableValue: true,
    field: "nbi_forcast_rgcp_y1_gbis",
    headerName: "RGCP Forecast- GBIS YR1",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimalWithPercentage,
    cellStyle: defaultNumberCellStyle,
    comparator: AgFormat.AgNumberComparatorNumeric,
    enableValue: true,
    field: "nbi_rgcp_1",
    headerName: "RGCP FY-1",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimalWithPercentage,
    cellStyle: defaultNumberCellStyle,
    comparator: AgFormat.AgNumberComparatorNumeric,
    enableValue: true,
    field: "nbi_rgcp_fy_1_gbis",
    headerName: "RGCP FY-1 - GBIS",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimalWithPercentage,
    cellStyle: defaultNumberCellStyle,
    comparator: AgFormat.AgNumberComparatorNumeric,
    enableValue: true,
    field: "nbi_rgcp_fy_2",
    headerName: "RGCP FY-2",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimalWithPercentage,
    cellStyle: defaultNumberCellStyle,
    comparator: AgFormat.AgNumberComparatorNumeric,
    enableValue: true,
    field: "nbi_rgcp_fy_3",
    headerName: "RGCP FY-3",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.calculateNbiVarWithoutPercent,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_rgcp_vs_fy_1",
    headerName: "RGCP YTD vs FY-1",
    width: 160,
  },
  {
    aggFunc: AgFormat.columnTotalBudget,
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_gbis_bud_obj",
    headerName: "NBI Budget Year",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellClass: defaultPercentCellClass,
    cellRenderer: Functions.calculateProgressMade,
    comparator: AgFormat.AgNumberComparatorNumeric,
    enableValue: true,
    field: "nbi_ytd_vs_nbi_gbis_bud_obj",
    headerName: "NBI YTD vs Budget",
    width: 160,
  },
  {
    aggFunc: AgFormat.columnTotalBudget,
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_gbis_bud_obj_ib",
    headerName: "NBI Budget - IB",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellClass: defaultPercentCellClass,
    cellRenderer: Functions.calculateProgressMade,
    comparator: AgFormat.AgNumberComparatorNumeric,
    enableValue: true,
    field: "nbi_ytd_vs_nbi_gbis_bud_obj_ib",
    headerName: "NBI YTD vs Budget - IB",
    width: 160,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_scbased_fy_1",
    headerName: "NBI SC based FY-1",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_scbased_fy_2",
    headerName: "NBI SC based FY-2",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_scbased_fy_1_ib",
    headerName: "NBI SC based FY-1 - IB",
    width: 125,
  },
  {
    aggFunc: "sum",
    cellRenderer: Functions.formatMoneyNoDecimal,
    cellStyle: defaultNumberCellStyle,
    enableValue: true,
    field: "nbi_scbased_fy_2_ib",
    headerName: "NBI SC based FY-2 - IB",
    width: 125,
  },
];
